
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_20312","data-name":"Group 20312","transform":"translate(-671 -372)"}},[_c('g',{attrs:{"id":"Subtraction_1","data-name":"Subtraction 1"}},[_c('path',{attrs:{"id":"Path_19304","data-name":"Path 19304","d":"M683.5 391a6.5 6.5 0 116.5-6.5 6.508 6.508 0 01-6.5 6.5zm-3.153-7.77a1.272 1.272 0 000 2.545h1.879v1.879a1.272 1.272 0 002.545 0v-1.879h1.879a1.272 1.272 0 000-2.545h-1.878v-1.878a1.272 1.272 0 10-2.545 0v1.878z"}})]),_c('g',{attrs:{"id":"Ellipse_36","data-name":"Ellipse 36"}},[_c('g',{attrs:{"id":"Group_20473","data-name":"Group 20473"}},[_c('circle',{attrs:{"id":"Ellipse_297","data-name":"Ellipse 297","cx":"12.5","cy":"12.5","r":"12.5","transform":"translate(671 372)"}})]),_c('g',{attrs:{"id":"Group_20474","data-name":"Group 20474"}},[_c('path',{attrs:{"id":"Path_19305","data-name":"Path 19305","d":"M683.5 397a12.5 12.5 0 1112.5-12.5 12.514 12.514 0 01-12.5 12.5zm0-24a11.5 11.5 0 1011.5 11.5 11.513 11.513 0 00-11.5-11.5z"}})])])])])
          )
        }
      }
    